import React from 'react';

import { Grid } from '@mui/material';

import Stats from './Stats';
import { Province } from '../../../@types/KingdomResponse';

interface Props {
  dataSet: Province[] | undefined;
  hideTotals: boolean;
  zoom: number;
}
const GridFooter: React.FC<Props> = ({ dataSet, hideTotals, zoom }) => {
  if (!dataSet || hideTotals) return null;
  return (
    <Grid container>
      <Grid sx={{ fontSize: `${zoom}%` }}>
        <Stats rows={dataSet} />
      </Grid>
    </Grid>
  );
};

export default GridFooter;
